const SriDots = ({sri}: {sri: number}) => {
    return (
        <>
            <div className="element-sri flex">
                {sri !== null ? (
                    <span className=" index">
                        {sri}
                        <span className="index-max">/7</span>
                    </span>
                ) : (
                    <span className="flex">&ndash;</span>
                )}
                <span className="row-ju row-ju-sri flex">SRI</span>
            </div>
        </>
    )
}

export default SriDots
